import React, { useEffect, useState } from 'react';
import { AddButton } from '../../components/mui/Buttons/Buttons';
// import { Button, Switch, FormControlLabel } from "@mui/material";
import { Form, FormikProvider, useFormik } from 'formik';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import BatchForm from './Batchform';
import {
  addCourseBatch,
  getAvailableCourses,
  getBatchesList,
  getCardsData,
  getClasses,
  getCourseAvailable,
  getOfflineCentersForSKillx,
  getSubjects,
  getSyllabus,
  getTutorsList,
  updateCourseBatch,
} from '../../redux/features/batchSlice';
import dayjs from 'dayjs';
import { Button } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';

const Addbatch = ({ dispatchParams, row, open, setOpen }) => {
  // const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, subjects, classes, syllabuses, allcourses, offlineCenters } = useSelector((state) => state.batch);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const ValidationSchema = Yup.object().shape({
    course_batch_name: Yup.string().required('Please enter batch name'),
    course_available_id: Yup.string().required('Course is required'),
    course_batch_capacity: Yup.number().required('Capacity is required'),
    course_batch_start_time: Yup.string().nullable().required('Time is required'),
    course_batch_end_time: Yup.string().nullable().required('Time is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      course_batch_name: row?.course_batch_name || '',
      class_mode: null,
      offline_center: null,
      course_available_id: row?.course_available_id || '',
      subjects:
        row?.subjects?.map((s) => ({
          subjectId: s.subject_id,
          subjectName: s.subject_name,
          priority: Number(s.priority),
        })) || [],
      course_batch_capacity: row?.course_batch_capacity || '',
      course_batch_start_date: row?.course_batch_start_date ? dayjs(row?.course_batch_start_date) : null,
      course_batch_class_id: row?.course_batch_class_id || null,
      course_category: row?.course_category || '',
      course_batch_start_time: row?.course_batch_start_time ? dayjs(`1970-01-01T${row.course_batch_start_time}`) : null,
      course_batch_end_time: row?.course_batch_end_time ? dayjs(`1970-01-01T${row.course_batch_end_time}`) : null,
      course_batch_syllabus_id: row?.course_batch_syllabus_id || null,
      //toggle fields
      allow_cro_view: Number(row?.allow_cro_view) === 1,
      sync_with_lens: row?.course_batch_id ? Number(row?.sync_with_lens) === 1 : true,
    },

    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      const commonPayload = {
        ...values,
        course_batch_start_date: dayjs(values.course_batch_start_date).format('YYYY-MM-DD'),
        course_batch_start_time: dayjs(values.course_batch_start_time).format('HH:mm:ss'),
        course_batch_end_time: dayjs(values.course_batch_end_time).format('HH:mm:ss'),

        // convert boolean to 1 / 0
        allow_cro_view: values.allow_cro_view ? 1 : 0,
        sync_with_lens: !!values.sync_with_lens,
        subjects: values.subjects.map((subject) => ({
          subject_id: subject.subjectId,
          priority: Number(subject.priority),
        })),
      };

      if (row?.course_batch_id) {
        const updatePayload = {
          ...commonPayload,
          course_batch_id: row?.course_batch_id,
        };
        dispatch(updateCourseBatch(updatePayload)).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, { variant: 'error' });
          } else if (res.payload.status === 'success') {
            enqueueSnackbar(res.payload.message, { variant: 'success' });
            dispatch(getBatchesList(dispatchParams));
            setOpen(false);
            formik.resetForm();
          }
        });
      } else {
        const addPayload = {
          data: [commonPayload],
        };

        dispatch(addCourseBatch(addPayload)).then((res) => {
          if (res.payload.status === 'success') {
            enqueueSnackbar(res.payload.message, { variant: 'success' });
            dispatch(getCardsData());
            dispatch(getBatchesList(dispatchParams));
            setOpen(false);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, { variant: 'error' });
          }
        });
      }
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getSubjects());
      dispatch(getSyllabus());
      dispatch(getClasses());
      dispatch(getOfflineCentersForSKillx());
      dispatch(getCourseAvailable());
    }
  }, [open]);

  const categoryData = [
    { id: 'Category 1', levelName: 'Category 1' },
    { id: 'Category 2', levelName: 'Category 2' },
    { id: 'Category 3', levelName: 'Category 3' },
    { id: 'Category 4', levelName: 'Category 4' },
  ];

  return (
    <GlobalDialog
      title={row?.course_batch_id ? 'Edit Batch' : 'Add Batch'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'md'}
      closeButton={true}
      // popupButton={
      //   row?.course_batch_id ? (
      //     <Button
      //       size="small"
      //       color="primary"
      //       variant="outlined"
      //       onClick={() => setOpen(true)}
      //     >
      //       <Icon icon={"mdi:edit"} width={18} height={18} />
      //     </Button>
      //   ) : (
      //     <Button
      //       size="medium"
      //       variant="outlined"
      //       color="primary"
      //       onClick={() => setOpen(true)}
      //     >
      //       <Icon icon={"ri:add-line"} width={18} height={18} />
      //       Add Batch
      //     </Button>
      //   )
      // }
      content={
        <>
          <BatchForm
            formik={formik}
            loading={loading}
            setOpen={setOpen}
            courseData={allcourses}
            subjects={subjects}
            classData={classes}
            syllabus={syllabuses}
            categories={categoryData}
            offlineCenters={offlineCenters}
            row={row}
          />
        </>
      }
    />
  );
};

export default Addbatch;
